<ion-header class="ion-no-border premium-header">
  <div class="header-curve"></div>
  <div class="custom-toolbar">
    <div class="toolbar-content">
      <ion-buttons slot="start">
        <div style="width: 44px;"></div>
      </ion-buttons>

      <div class="title-group">
        <div class="title-main">Detalles del Item</div>
        <div class="title-sub">{{trabajoItem?.descripcion}}</div>
      </div>

      <ion-buttons slot="end">
        <ion-button (click)="close()" class="icon-btn">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </div>
  </div>
</ion-header>

<ion-toolbar class="segment-toolbar">
    <ion-segment (ionChange)="segmentChanged($event)" [value]="segment" scrollable mode="ios" class="premium-segment">
      <ion-segment-button value="GENERAL">
        <ion-label>General</ion-label>
      </ion-segment-button>
      <ion-segment-button value="ANTES">
        <ion-label>Antes</ion-label>
      </ion-segment-button>
      <ion-segment-button value="DESPUES">
        <ion-label>Después</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
<ion-content class="premium-content-bg ion-padding">

  <div class="item-info ion-margin-bottom">
    <h2 class="ion-no-margin">{{trabajoItem?.descripcion}}</h2>
    <!-- Quantity removed as requested -->
  </div>

  <!-- Empty State -->
  <div *ngIf="filteredDetails.length === 0" class="empty-state">
    <ion-icon name="albums-outline"></ion-icon>
    <p>No hay registros en esta sección</p>
  </div>

  <!-- Timeline / Grid -->
  <div class="details-grid">
    <ion-card *ngFor="let d of filteredDetails" class="premium-card detail-card">

      <!-- Image Type -->
      <div *ngIf="d.tipo === 'IMAGEN'" class="img-container">
        <ng-container
          *ngIf="d.imagen_path | imageAuth:'path_img_trabajos_items' | async as imageSrc; else loadingImage">
          <img [src]="imageSrc" alt="Foto" class="detail-img fade-in" (click)="javapiService.getImage(d.imagen_path)" />
        </ng-container>
        <ng-template #loadingImage>
          <div class="loading-skeleton">
            <ion-skeleton-text animated style="width: 100%; height: 100%; border-radius: 0;"></ion-skeleton-text>
          </div>
        </ng-template>
      </div>

      <!-- Note Type or Caption -->
      <ion-card-content>
        <p *ngIf="d.texto" class="detail-text">{{d.texto}}</p>
        <div class="detail-meta">
          <ion-badge [color]="d.tipo === 'NOTA' ? 'warning' : 'medium'">{{d.tipo}}</ion-badge>
          <span class="date">{{d.fecha | date:'short'}}</span>
        </div>
      </ion-card-content>
    </ion-card>
  </div>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button>
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
    <ion-fab-list side="top">
      <ion-fab-button (click)="addPhoto()" color="secondary">
        <ion-icon name="camera"></ion-icon>
      </ion-fab-button>
      <ion-fab-button (click)="addNote()" color="tertiary">
        <ion-icon name="document-text"></ion-icon>
      </ion-fab-button>
    </ion-fab-list>
  </ion-fab>

</ion-content>
